<template>
  <div>
    <img class="mx-auto h-20" :src="imagePath" alt='EZRack Logo'>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'RmsLogo',
  components: {},
  props: {
    logoColor: {
      type: String,
      required: false,
      default: '',
    }
  },

  setup(props) {
    const imagePath = computed(() => {
      return `/assets/images/logos/EZRackLogo${props.logoColor}.svg`
    })

    return {
      imagePath,
    }
  },

}
</script>
